import React, { Component } from "react";
import IconWithBackground from "containers/chat/IconWithBackground/IconWithBackground";
import { ReactComponent as EnvelopeFill } from "images/cannedmessage/envelope-fill.svg";
import "./AddCannedMessageForm.scss";
import RadioGroup from "components/RadioGroup/RadioGroup";
import { uepClient } from "uepClient";
import Button from "Button/Button";
import WithAlert from "hoc/WithAlert";
import { UserBU, UserGroup } from "constants/UserConstants";
import { cvSalesBaseURL, pvBaseURL, cvServiceBaseURL } from "uepClient";
import CreatableSelect from "react-select/creatable";
import { getBusinessUnit } from "utils/Common";

class AddCannedMessageForm extends Component {
  constructor() {
    super();
    this.state = {
      group: null,
      category: null,
      message: null,
      isLoading: true,
      isFormSubmissionInProgress: false,
    };
    this.cannedMsgCreationData = [];
    this.categoryOptions = [];
  }

  getBUGroupSpecificAPIBaseUrl = (group) => {
    let apiBaseUrl = pvBaseURL;
    const businessUnit = getBusinessUnit();
    if (businessUnit === UserBU.CV) {
      apiBaseUrl =
        group === UserGroup.SALES ? cvSalesBaseURL : cvServiceBaseURL;
    }
    return apiBaseUrl;
  };

  componentDidMount() {
    this.populateFormWithExistingCannedMsgDetails();
  }

  fetchCategories = () => {
    const { group } = this.state;

    uepClient({ baseURL: this.getBUGroupSpecificAPIBaseUrl(group) })
      .get(`/canned-message/types/${group}`)
      .then((res) => {
        this.categoryOptions = res.data;
        this.categoryOptions = res.data.map((category) => {
          return {
            value: category,
            label: category,
          };
        });
        this.setState({
          isLoading: false,
        });
      })
      .catch((err) => {
        console.error(err.message);
      });
  };

  populateFormWithExistingCannedMsgDetails = () => {
    const { cannedMsgToUpdate, isEditMode } = this.props;
    if (isEditMode && cannedMsgToUpdate) {
      const selectedCategory = {
        value: cannedMsgToUpdate.type,
        label: cannedMsgToUpdate.type,
      };

      this.setState(
        {
          group: cannedMsgToUpdate.group,
          category: selectedCategory,
          message: cannedMsgToUpdate.body,
        },
        this.fetchCategories
      );
    }
  };

  onFormSubmit = (e) => {
    e.preventDefault();
    const { isEditMode } = this.props;
    isEditMode
      ? this.submitCannedMsgEditForm()
      : this.submitCannedMsgCreationForm();
  };

  submitCannedMsgCreationForm = () => {
    const { category, message, group } = this.state;

    const { onFormClose, addNewCannedMsgToTable } = this.props;

    const cannedMsgCreationData = {
      message: message,
      category: category.value,
      group: group,
    };
    this.setState({ isFormSubmissionInProgress: true });

    uepClient()
      .post("/canned-message/add", JSON.stringify(cannedMsgCreationData))
      .then((res) => {
        const cannedMsgData = res.data;
        this.setState({ isFormSubmissionInProgress: false });
        this.props.showAlert({
          variant: "success",
          content: (
            <span>
              <b>Success!</b> The canned message has been created successfully.
            </span>
          ),
        });
        addNewCannedMsgToTable(cannedMsgData);
      })
      .catch((err) => {
        const errorMessageToDisplay =
          err.response.status === 409
            ? err.response.data
            : "Failed to add canned message, Please try again.";
        this.props.showAlert({
          variant: "danger",
          content: (
            <span>
              <b>Error!</b> {errorMessageToDisplay}
            </span>
          ),
        });
        console.error(err.message);
        this.setState({ isFormSubmissionInProgress: false });
      })
      .finally(() => {
        onFormClose();
      });
  };

  submitCannedMsgEditForm = () => {
    const { category, message, group } = this.state;

    const {
      onFormClose,
      updateCannedMsgInTable,
      cannedMsgToUpdate,
    } = this.props;

    const updatedCannedMsgData = {
      id: cannedMsgToUpdate.id,
      message: message,
      category: category.value,
      group: group,
    };
    this.setState({ isFormSubmissionInProgress: true });

    uepClient()
      .put("/canned-message/edit", JSON.stringify(updatedCannedMsgData))
      .then((res) => {
        const cannedMessageData = res.data;
        this.setState({ isFormSubmissionInProgress: false });
        this.props.showAlert({
          variant: "success",
          content: (
            <span>
              <b>Success!</b> The canned message has been updated successfully.
            </span>
          ),
        });
        updateCannedMsgInTable(cannedMessageData);
      })
      .catch((err) => {
        const errorMessageToDisplay =
          err.response.status === 409
            ? err.response.data
            : "Failed to update canned message, Please try again.";
        this.props.showAlert({
          variant: "danger",
          content: (
            <span>
              <b>Error!</b> {errorMessageToDisplay}
            </span>
          ),
        });
        console.error(err.message);
        this.setState({ isFormSubmissionInProgress: false });
      })
      .finally(() => {
        onFormClose();
      });
  };

  getBUOptions = () => {
    return [
      {
        value: UserBU.CV,
        label: "CV",
      },
      {
        value: UserBU.PV,
        label: "PV",
      },
    ];
  };

  getGroupOptions = () => {
    const businessUnit = getBusinessUnit();
    if (businessUnit === UserBU.PV) {
      return [
        {
          value: UserGroup.SALES,
          label: "Sales",
        },
      ];
    }
    return [
      {
        value: UserGroup.SALES,
        label: "Sales",
      },
      {
        value: UserGroup.SERVICE,
        label: "Service",
      },
      {
        value: UserGroup.FLEET_EDGE,
        label: "FLEET EDGE",
      },
    ];
  };

  renderFormInputWithHeader = (header, content, isBoldHeader = true) => {
    const boldHeaderCls = isBoldHeader ? "bold" : "normal";
    return (
      <div className="form-input-with-header">
        <div className={`form-section-header ${boldHeaderCls}`}>{header}</div>
        <div className="form-section-content">{content}</div>
      </div>
    );
  };

  onGroupChange = (group) => {
    this.setState(
      {
        group,
      },
      this.fetchCategories
    );
  };

  getCategoryOptions = () => {
    return this.categoryOptions;
  };

  onCategoryChange = (selectedCategory) => {
    this.setState({
      category: selectedCategory,
    });
  };

  onMessageChange = (e) => {
    this.setState({
      [e.target.message]: e.target.value,
      message: e.target.value,
    });
  };

  getSelectedDropdownOptionValues = (selectedDropdownOptions) => {
    let values = [];
    if (selectedDropdownOptions && selectedDropdownOptions !== null) {
      values = selectedDropdownOptions.map((option) => {
        return option.value;
      });
    }
    return values;
  };

  getDropdownStyles = () => {
    const customStyles = {
      container: (provided) => ({
        ...provided,
        width: "100%",
      }),
      control: (provided, { isDisabled }) => ({
        ...provided,
        width: "100%",
        minWidth: 120,
        height: 34,
        minHeight: 34,
        font: "normal normal bold 14px/19px Roboto",
        background: "white",
        paddingLeft: "0px",
        opacity: isDisabled ? 0.5 : 1,
        boxShadow: "0px 3px 6px #00000029",
        border: 0,
      }),
      option: (provided) => ({
        ...provided,
        width: "100%",
        minWidth: 120,
        font: "Roboto",
        border: "none",
      }),
      dropdownIndicator: (provided, state) => ({
        ...provided,
        width: 28,
        paddingTop: 0,
        paddingBottom: 0,
        color: "#3c3c3f",
        transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : null,
      }),
      multiValue: (provided) => ({
        ...provided,
        fontFamily: "Roboto",
        color: "#96969B",
      }),
      multiValueRemove: (provided) => ({
        ...provided,
        color: "#96969B",
        "&:hover": {
          backgroundColor: "#3A8AFA",
          color: "#fff",
        },
      }),
      menu: (provided) => ({
        ...provided,
      }),
      placeholder: (provided) => ({
        ...provided,
        fontWeight: "normal",
      }),
    };
    return customStyles;
  };

  canSubmit = () => {
    const { group, category, message } = this.state;
    return group && category && message;
  };

  onFormClose = () => {
    const { onFormClose } = this.props;
    onFormClose();
  };

  onFormCancel = (e) => {
    e.preventDefault();
    this.onFormClose();
  };

  render() {
    const {
      group,
      category,
      message,
      isLoading,
      isFormSubmissionInProgress,
    } = this.state;

    const { isEditMode } = this.props;
    return (
      <div className="add-canned-msg-form">
        <div className="add-canned-msg-form-header">
          <div className="canned-msg-icon-ctr">
            <IconWithBackground
              icon={<EnvelopeFill className="canned-msg-icon" />}
            />
          </div>
          <div className="header-label">
            {isEditMode ? "Edit Canned Message" : "Add Canned Message"}
          </div>
        </div>
        <div className="form-content">
          <form className="canned-msg-form" onSubmit={this.onFormSubmit}>
            <div className="form-section group">
              {this.renderFormInputWithHeader(
                "Group",
                <RadioGroup
                  options={this.getGroupOptions()}
                  onChange={this.onGroupChange}
                  value={group}
                />
              )}
            </div>
            <div className="form-section category">
              {this.renderFormInputWithHeader(
                <span>Category </span>,
                <CreatableSelect
                  onChange={this.onCategoryChange}
                  value={category}
                  options={this.getCategoryOptions()}
                  placeholder="Select Category"
                  styles={this.getDropdownStyles()}
                  isLoading={isLoading}
                  creatable
                />,
                true
              )}
            </div>
            <div className="form-section message">
              {this.renderFormInputWithHeader(
                <span>Message </span>,
                <textarea
                  className="msg-textbox"
                  onChange={this.onMessageChange}
                  name="cannedMessage"
                  maxLength={65000}
                  value={message}
                />,
                true
              )}
            </div>
            <div className="buttons-container">
              <Button
                className="form-cancel-btn"
                label="Cancel"
                disabled={isFormSubmissionInProgress}
                onClick={this.onFormCancel}
                isTransparent
              />
              <Button
                className="form-submit-btn"
                type="submit"
                label={isEditMode ? "Update" : "Add"}
                disabled={!this.canSubmit()}
                isLoading={isFormSubmissionInProgress}
              />
            </div>
          </form>
        </div>
      </div>
    );
  }
}

const AddCannedMessageFormWithAlert = WithAlert(AddCannedMessageForm);

export default AddCannedMessageFormWithAlert;
